/*
 *
 * Do not edit directly
 * Generated on Fri, 14 Feb 2025 18:58:13 GMT
 *
 */

import PaletteIconChevronRight from '@telus-uds/palette-public-mobile/build/rn/icons/ChevronRight'
const theme = {
  appearances: { inverse: { type: 'variant', values: [ true ] } },
  rules: [
    {
      if: { inverse: true },
      tokens: {
        color: '#f9f2dd',
        currentColor: '#f5f5f7',
        iconColor: '#9c9faa'
      }
    }
  ],
  tokens: {
    color: '#636c8c',
    currentColor: '#394056',
    fontName: 'SofiaPro',
    fontSize: 16,
    fontWeight: '400',
    icon: PaletteIconChevronRight,
    iconColor: '#9c9faa',
    iconContainerSize: 24,
    iconPadding: 4,
    iconSize: 24,
    lineHeight: 1.5,
    listItemPadding: 0
  }
}
export default theme
